module.exports = __webpack_public_path__ + "static/media/download_file.51501be4.svg";